var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},React.createElement("path",{"d":"M7.526 19.235a.794.794 0 0 0 .79.765h7.369a.794.794 0 0 0 .789-.765L17 8H7l.526 11.235zm6.141-8.444c0-.18.144-.325.32-.325h.514c.177 0 .32.146.32.325v6.418c0 .18-.143.325-.32.325h-.513a.322.322 0 0 1-.32-.325v-6.418zm-2.244 0c0-.18.143-.325.32-.325h.513c.177 0 .321.146.321.325v6.418c0 .18-.143.325-.32.325h-.513a.322.322 0 0 1-.321-.325v-6.418zm-2.244 0c0-.18.143-.325.32-.325h.513c.177 0 .32.146.32.325v6.418c0 .18-.143.325-.32.325H9.5a.322.322 0 0 1-.32-.325v-6.418zM17.492 5.565h-3.49v-.45c0-.063-.076-.115-.17-.115h-3.664c-.094 0-.17.052-.17.116v.45h-3.49c-.28 0-.508.154-.508.346V7h12V5.912c0-.192-.228-.347-.508-.347z"})));
}

Trash.defaultProps = {"viewBox":"0 0 24 24","width":"24","height":"24"};

module.exports = Trash;

Trash.default = Trash;
